import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const General1 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <g transform="translate(0, 0)">
        <path
          d="M15.4,3.1l-7-3C8.1,0,7.9,0,7.6,0.1l-7,3C0.2,3.2,0,3.6,0,4v8c0,0.4,0.2,0.8,0.6,0.9l7,3C7.7,16,7.9,16,8,16
	s0.3,0,0.4-0.1l7-3c0.4-0.2,0.6-0.5,0.6-0.9V4C16,3.6,15.8,3.2,15.4,3.1z M8,2.1L12.5,4L8,5.9L3.5,4L8,2.1z M2,5.5l5,2.1v5.8l-5-2.1
	V5.5z M9,13.5V7.7l5-2.1v5.8L9,13.5z"
        />
      </g>
    </svg>
  );
};

General1.category = 'product-category';

General1.displayName = 'General1';
